<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>The author was born in Cyprus in 1944 to a happy but somewhat-unconventional family. John came to England in 1948 and was educated in London. He has been very happily married to Barbara since 1969, having run a business with his wife. John has three children, two boys and one girl, and a football team of grandchildren.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?21808d05